import Btn from './Button';
import { useSettings } from '../../context/SettingsContext';
import en from '../../locales/en.json';
import hi from '../../locales/hi.json';
import gu from '../../locales/gu.json';

const translations = { en, hi, gu };

export default function Pagination({ page, total, perPage = 15, onPage, className = "mt-4 pt-3 border-t border-border dark:border-slate-700/60" }) {
  const { language = 'en' } = useSettings();
  const t = (key, params) => {
    let str = translations[language]?.common?.[key] || translations.en?.common?.[key] || key;
    if (params) {
      Object.keys(params).forEach(p => { str = str.replace(`{${p}}`, params[p]); });
    }
    return str;
  };

  const totalPages = Math.ceil(total / perPage);
  if (total === 0) return null;

  const from = (page - 1) * perPage + 1;
  const to = Math.min(page * perPage, total);

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between gap-3 w-full ${className}`}>
      <span className="text-xs text-muted dark:text-slate-400 text-center sm:text-left">
        {t("showing_records", {
          from,
          to,
          total: `<strong class="text-ink dark:text-white font-semibold">${total}</strong>`
        }) ? (
          <span
            dangerouslySetInnerHTML={{
              __html: t("showing_records", {
                from,
                to,
                total: `<strong class="text-ink dark:text-white font-semibold">${total}</strong>`
              })
            }}
          />
        ) : (
          <>
            Showing {from}–{to} of <strong className="text-ink dark:text-white">{total}</strong> records
          </>
        )}
      </span>
      <div className="flex gap-1 sm:gap-1.5 items-center justify-center flex-wrap max-w-full">
        <Btn xs disabled={page === 1} onClick={() => onPage(page - 1)}>
          ← {t("btn_prev", "Prev")}
        </Btn>
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          const p = totalPages <= 5 ? i + 1 : page <= 3 ? i + 1 : page >= totalPages - 2 ? totalPages - 4 + i : page - 2 + i;
          return (
            <button
              key={p}
              type="button"
              onClick={() => onPage(p)}
              className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg text-xs font-semibold cursor-pointer border-0 transition-all flex items-center justify-center ${
                p === page
                  ? "bg-primary text-white shadow-xs"
                  : "bg-transparent text-muted dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"
              }`}
            >
              {p}
            </button>
          );
        })}
        <Btn xs disabled={page === totalPages || totalPages === 0} onClick={() => onPage(page + 1)}>
          {t("btn_next", "Next")} →
        </Btn>
      </div>
    </div>
  );
}
